import React from 'react'
import { useReservationContext } from './ReservationContext'
import ErrorIcon from '@assets/img/reservation/error-icon.svg'
import classNames from 'classnames'

const PersonalDataDetails = () => {
    const { form, handleChange, errors, t } = useReservationContext()

    return (
        <div className="trip-reservation__personal-data">
            <label className="trip-reservation__label trip-reservation__label--full">
                {t('address-details')}
                <input
                    placeholder={t('enter-full-address')}
                    value={form.address}
                    onChange={handleChange}
                    name="address"
                    className={classNames('trip-reservation__input', {
                        'trip-reservation__input--error': errors.email,
                    })}
                />
                {errors.address ? (
                    <>
                        <div className="trip-reservation__error">{errors.address[0]}</div>
                        <img className="trip-reservation__error-icon" src={ErrorIcon} alt="" />
                    </>
                ) : null}
            </label>
            <label className="trip-reservation__label">
                {t('postal-code')}
                <input
                    placeholder={t('enter-postal-code')}
                    value={form.postcode}
                    onChange={handleChange}
                    name="postcode"
                    className={classNames('trip-reservation__input', {
                        'trip-reservation__input--error': errors.email,
                    })}
                />
                {errors.postcode ? (
                    <>
                        <div className="trip-reservation__error">{errors.postcode[0]}</div>
                        <img className="trip-reservation__error-icon" src={ErrorIcon} alt="" />
                    </>
                ) : null}
            </label>
            <label className="trip-reservation__label">
                {t('city')}
                <input
                    placeholder={t('enter-city')}
                    value={form.city}
                    onChange={handleChange}
                    name="city"
                    className={classNames('trip-reservation__input', {
                        'trip-reservation__input--error': errors.email,
                    })}
                />
                {errors.city ? (
                    <>
                        <div className="trip-reservation__error">{errors.city[0]}</div>
                        <img className="trip-reservation__error-icon" src={ErrorIcon} alt="" />
                    </>
                ) : null}
            </label>
        </div>
    )
}

export default PersonalDataDetails
